export default __webpack_public_path__ + "static/media/thumbnail.68efae8a.png";